import { useTranslation } from 'react-i18next'

import { CardTitle, Drawer } from '@reveni-io/reveni-ui'

import EditTransactionAmount from '@/returns/components/EditTransactionAmount/EditTransactionAmount'

const EditAmountsDrawer = ({
  show,
  onClose,
  lineItems,
  concepts,
  currency,
  refundMethods,
  refundMethod,
  onSave,
  returnId,
  loading,
}) => {
  const { t } = useTranslation()
  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle>{t('Editar resultado transacción')}</CardTitle>
      <EditTransactionAmount
        show={show}
        onClose={onClose}
        lineItems={lineItems}
        concepts={concepts}
        currency={currency}
        refundMethods={refundMethods}
        refundMethod={refundMethod}
        onSave={onSave}
        returnId={returnId}
        loading={loading}
        directionActionButtons="column"
      />
    </Drawer>
  )
}

export default EditAmountsDrawer
